export * from "./lms-reporting";

export enum AnnouncementTypesColors {
  "PLATFORM_UPDATES" = "#00B2B1",
  "NEW_CARRIER" = "#AFD100",
  "ROAD_NOTICES" = "#808080",
  "FIRE_NOTICES" = "#FC0000",
  "PROMOS" = "#B37CC4",
  "ISSUES" = "#251163",
}

export enum AnnouncementTypesTitles {
  "PLATFORM_UPDATES" = "Platform Updates",
  "NEW_CARRIER" = "New Carrier",
  "ROAD_NOTICES" = "Road Notices",
  "FIRE_NOTICES" = "Fire Notices",
  "PROMOS" = "Promos",
  "ISSUES" = "Issues",
}

export const announcementTypes = [
  { value: "PLATFORM_UPDATES", label: "Platform Updates" },
  { value: "NEW_CARRIER", label: "New Carrier" },
  { value: "ROAD_NOTICES", label: "Road Notices" },
  { value: "FIRE_NOTICES", label: "Fire Notices" },
  { value: "PROMOS", label: "Promos" },
  { value: "ISSUES", label: "Issues" },
];

export const lmsItemStatus = [
  { value: "On_Hand", label: "On Hand" },
  { value: "LOADED", label: "Loaded" },
  { value: "In_Transit", label: "In Transit" },
  { value: "Final_Destination", label: "Final Destination" },
  { value: "DELIVERED", label: "Delivered" },
  { value: "Deconsolidated", label: "Deconsolidated" },
];

export const lmsItemsPriority = [
  { value: "Normal", label: "Normal" },
  { value: "High", label: "High" },
  { value: "Winter_Road", label: "Winter Road" },
  { value: "Hercules_Freight", label: "Hercules Freight" },
];

export const lmsLineItemsPriority = [
  { value: "CODE 99", label: "Code 99" },
  { value: "RUSH", label: "Rush" },
  { value: "NORMAL", label: "Normal" },
  { value: "Hercules_Freight", label: "Hercules Freight" },
];

export const DEFAULT_PAGE_SIZE = 25;
export const pageSizeOptions: number[] = [25, 50, 75, 100, 125];
